import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "plain-javascript-samples"
    }}>{`Plain JavaScript Samples`}</h1>
    <p>{`Plain (also called "Vanilla") JavaScript is JavaScript without any libraries or frameworks. Because of that, it's also the easiest environment in which to show examples.`}</p>
    <p>{`The examples are described briefly below. You can find the source code for these in GitHub `}<a parentName="p" {...{
        "href": "https://github.com/AdobeDocs/uxp-photoshop-plugin-samples"
      }}>{`here`}</a>{`.`}</p>
    <h2 {...{
      "id": "direct-action-headless"
    }}>{`Direct Action ("headless")`}</h2>
    <p>{`The simplest of all plugin patterns in terms of UI. A "headless" plugin is one that has no user interface. When the user selects the plugin from Photoshop's Plugins menu, the plugin runs silently.`}</p>
    <p>{`Why would you want to do this? If your plugin only does one thing, and has no options or user-entered parameters, you could create it without any UI. The only time you would need a UI would be if the plugin failed in some way, at which point you should display a message describing the failure.`}</p>
    <p><a parentName="p" {...{
        "href": "https://github.com/AdobeDocs/uxp-photoshop-plugin-samples/tree/main/direct-action-js-sample"
      }}>{`This example`}</a>{` shows how to get the layer names of the current document and write them to a file. No user interaction is involved.`}</p>
    <h2 {...{
      "id": "hello-world-alert"
    }}>{`Hello, World Alert`}</h2>
    <p>{`In the spirit of the gold standard for trivial examples since the publication of `}<em parentName="p">{`The C Programming Language`}</em>{` book in 1978 (and `}<a parentName="p" {...{
        "href": "https://www.thesoftwareguild.com/blog/the-history-of-hello-world/"
      }}>{`earlier`}</a>{`), `}<a parentName="p" {...{
        "href": "https://github.com/AdobeDocs/uxp-photoshop-plugin-samples/tree/main/hello-world-js-sample"
      }}>{`this plugin example`}</a>{` does nothing but display a Photoshop alert. But it gives you the idea of the structure of simple plugins that use only pure JavaScript (no HTML or CSS).`}</p>
    <h2 {...{
      "id": "hello-world-panel"
    }}>{`Hello, World Panel`}</h2>
    <p>{`A Panel is a common interface element in Photoshop. Panels are everywhere. You would choose to create a panel-based plugin if you had a UI that needed to persist, as opposed to appearing once and then being dismissed (i.e., a modal dialog).`}</p>
    <p>{`This is a variant on the plugin above that displays a panel with two buttons. When one button is clicked, the plugin displays a Photoshop alert. Another button fills a list with layer names from the current document. `}</p>
    <p><a parentName="p" {...{
        "href": "https://github.com/AdobeDocs/uxp-photoshop-plugin-samples/tree/main/hello-world-panel-js-sample"
      }}>{`This plugin`}</a>{` shows how you use an index.html file, some basic CSS, and how to capture UI events to trigger plugin actions.`}</p>
    <h2 {...{
      "id": "layer-creation-and-population"
    }}>{`Layer Creation and Population`}</h2>
    <p><a parentName="p" {...{
        "href": "https://github.com/AdobeDocs/uxp-photoshop-plugin-samples/tree/main/layer-creation-js-sample"
      }}>{`This panel-based plugin`}</a>{` lets you type text into an input field, then press a button to create a layer containing that text. It also allows you to read the text from a file. This shows input field processing, file I/O, and some debugging techniques.`}</p>
    <h2 {...{
      "id": "web-service-query"
    }}>{`Web Service Query`}</h2>
    <p><a parentName="p" {...{
        "href": "https://github.com/AdobeDocs/uxp-photoshop-plugin-samples/tree/main/web-service-call-js-sample"
      }}>{`This plugin`}</a>{` demonstrates the common use case of needing to talk to an external website (using `}<inlineCode parentName="p">{`fetch`}</inlineCode>{`) to obtain some information that's then used in the document. It then creates a document with a layer containing the data returned from the website.`}</p>
    <h2 {...{
      "id": "theme-awareness"
    }}>{`Theme Awareness`}</h2>
    <p>{`The Photoshop UI supports multiple "themes" (light, dark, etc.). You can use CSS selectors to change the way your UI looks depending upon what theme the user picks in Photoshop Preferences->Interface. `}<a parentName="p" {...{
        "href": "https://github.com/AdobeDocs/uxp-photoshop-plugin-samples/tree/main/ui-kitchen-sink"
      }}>{`This sample`}</a>{` shows the CSS and HTML necessary to make your plugin aware of user-initiated theme changes, and change your color scheme accordingly.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      